import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCreateOptions from "UI/FnrCreateOptions/FnrCreateOptions";
import FnrDivider from "UI/FnrDivider/FnrDivider";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import extendedFieldInputContainers from "../containers";

const { IconContainer } = extendedFieldInputContainers;

const confirmText =
  "Are you sure you want to remove this option? This may affect data previously obtained for users.";

const Options = () => {
  const [multiOption, setMultiOptions] = extendedFieldHooks.useMultiOptions();
  const [options, setOptions] = extendedFieldHooks.useOptions();
  const handleSetMultiOptions = () => setMultiOptions(!multiOption);
  const isReadyOnly = extendedFieldHooks.useIsReadOnly();

  return (
    <FnrCard data-cy="ExtendedField_Options">
      <FnrVerticalGap>
        <FnrHorizontalGap centered>
          <FnrTypography fontSize="xl" gutterBottom>
            Options
          </FnrTypography>
        </FnrHorizontalGap>
        <FnrCreateOptions
          options={options}
          setOptions={setOptions}
          confirmText={confirmText}
          disabled={isReadyOnly}
        />
        <FnrDivider />
        <FnrHorizontalGap>
          <IconContainer $color="textSecondary">
            <FnrIcon icon="fa-ballot-check far" />
          </IconContainer>
          <FnrVerticalGap gap={8}>
            <FnrTypography>
              Allow users to select more than one option?
            </FnrTypography>
            <FnrCheckbox
              on={multiOption}
              toggleOn={handleSetMultiOptions}
              data-cy="Options_MultipleCheckbox"
              disabled={isReadyOnly}
            >
              Allow Multiple Options
            </FnrCheckbox>
          </FnrVerticalGap>
        </FnrHorizontalGap>
      </FnrVerticalGap>
    </FnrCard>
  );
};

export default Options;
